import { Divider, Select, Input } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ACTION } from "../../util/utils";
import "./../../styles/OpenPull.scss";
import TableFilter from "../common/TableFilter/TableFilter";
import Button from "../common/Button/Button";
import Breadcrumb from "../common/Breadcrumb/Breadcrumb";
import Label from "../common/Label/Label";
import { useMsal } from "@azure/msal-react";
import GenericGrid from "../common/Grid/GenericGrid";
import { fetchPicker, MODULE_KEY as FRAME_PICK_MODULE_KEY } from "../framePick/actions";
import { fetchEcomOrdersList, processEcomOrders, fetchEcomShipping, cancelEcomOrders, MODULE_KEY } from "./ecomOrders-actions";
import filterColumns from "./filterColumns";
import { MRT_RowSelectionState } from "material-react-table";
import ShippingConfig from "./ShippingConfig";

const { Option } = Select;

function EcomOrders() {
  const dispatch = useDispatch();
  const [pickerId, setPickerId] = useState<any>(undefined);
  const [selectedRow, setSelectedRow] = useState<any>([]);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [trackingNumber, setTrackingNumber] = useState("");
  const [shippingConfigVisible, setShippingConfigVisible] = useState(false);
  const [selectedShipping, setSelectedShipping] = useState<any>(undefined);

  const { picker } = useSelector(
    (state: any) => state[`${FRAME_PICK_MODULE_KEY}${ACTION.STATE_KEY}`]
  );

  const { shippingConfig } = useSelector(
    (state: any) => state[`${MODULE_KEY}${ACTION.STATE_KEY}`]
  );

  let filterValues = filterColumns();

  const unAssignedPicker = picker?.filter(
    (a: { PickerName: string }) => a.PickerName === "Unassigned"
  );
  const remainingPicker = picker?.filter(
    (a: { PickerName: string }) => a.PickerName !== "Unassigned"
  );
  const pickerArr = remainingPicker?.sort(
    (a: { PickerName: string }, b: { PickerName: string }) => {
      return a.PickerName.localeCompare(b.PickerName);
    }
  );
  const finalPickerArr = [...(unAssignedPicker || []), ...(pickerArr || [])];

  useEffect(() => {
    dispatch(fetchPicker({}));
    dispatch(fetchEcomShipping());
  }, []);

  useEffect(() => {
    if (shippingConfig?.data && shippingConfig.data.length > 0) {
      const defaultShipping = shippingConfig.data.find((item: any) => item.IsDefaultEcomShipping);
      if (defaultShipping) {
        setSelectedShipping(defaultShipping.Id);
      }
    }
  }, [shippingConfig?.data]);

  useEffect(() => {
    const selectedIds = Object.keys(rowSelection).filter(id => rowSelection[id]);
    const selectedRows = selectedIds.map(index => filterValues.data[parseInt(index)]);
    setSelectedRow(selectedRows);
  }, [rowSelection]);

  const spinning = filterValues.loading;
  return (
    <div>
      <Divider />
      <Breadcrumb>
        <span>Ecom Orders</span>
      </Breadcrumb>
      <TableFilter>
        <div className="form align-items-end">
          <Label label="Select Picker">
            <Select
              placeholder="Select Picker"
              disabled={spinning}
              showSearch
              value={pickerId}
              style={{ width: 120 }}
              optionFilterProp="children"
              onSelect={(value: string) => {
                setPickerId(value);
              }}
              size="small"
            >
              <Option value={undefined}>Select Picker</Option>
              {finalPickerArr
                ?.filter(({ EmployeeId }: any) => EmployeeId && EmployeeId !== 0)
                .map(
                ({ PickerId, PickerName }: any) => {
                  return (
                    <Option key={PickerId} value={PickerId}>
                      {PickerName}
                    </Option>
                  );
                }
              )}
            </Select>
          </Label>
          <Label label="Select Shipping">
            <Select
              placeholder="Select Shipping"
              disabled={spinning}
              showSearch
              value={selectedShipping}
              style={{ width: 150 }}
              optionFilterProp="children"
              onSelect={(value: string) => {
                setSelectedShipping(value);
              }}
              size="small"
            >
              {shippingConfig?.data?.map((shipping: any) => (
                <Option key={shipping.Id} value={shipping.Id}>
                  {shipping.Name}
                </Option>
              ))}
            </Select>
          </Label>
          <Label label="Tracking Number">
            <Input
              value={trackingNumber}
              onChange={e => setTrackingNumber(e.target.value)}
              placeholder="Enter tracking number"
              style={{ width: 200, backgroundColor: 'white' }}
              size="small"
              disabled={spinning || selectedRow.length === 0}
            />
          </Label>
          <Button
            style={{ marginRight: 8 }}
            disabled={spinning}
            onClick={() => {
              dispatch(fetchEcomOrdersList());
            }}
            size="middle"
          >
            Pull Orders
          </Button>

          <Button
            disabled={spinning || selectedRow.length === 0 || !trackingNumber }
            onClick={() => {
                const itemIds = selectedRow.map((row: any) => row.EcomOrderItemId);
              dispatch(processEcomOrders({ ItemIds: itemIds, PickerId: pickerId, TrackingNumber: trackingNumber, ShippingId: selectedShipping }));
                setRowSelection({});
                setTrackingNumber("");
            }}
            size="middle"
          >
            Process Order
          </Button>

          <Button
            disabled={spinning || selectedRow.length === 0}
            onClick={() => {
              const itemIds = selectedRow.map((row: any) => row.EcomOrderItemId);
              dispatch(cancelEcomOrders({ ItemIds: itemIds }));
              setRowSelection({});
            }}
            size="middle"
            style={{ marginLeft: 8 }}
          >
            Cancel Order
          </Button>
          
          <Button
            style={{ marginLeft: 8 }}
            onClick={() => setShippingConfigVisible(true)}
            size="middle"
          >
            Shipping Config
          </Button>
        </div>
      </TableFilter>
      <GenericGrid
        columns={filterValues.columns}
        data={filterValues.data}
        enableRowSelection={true}
        onRowSelectionChange={setRowSelection}
        rowSelection={rowSelection}
        setRowSelection={setRowSelection}
        columnVisibility={{}}
        columnPinning={{ left: ['mrt-row-select', 'OfficeNum'], right: ['actions'] }}
        enableColumnOrdering={false}
        filterDisplayMode="popover"
        highlightFilterMatch={true}
        paginationDisplayMode="pages"
        paginationProps={{
          color: 'primary',
          shape: 'rounded',
          showRowsPerPage: true,
          variant: 'outlined',
          rowsPerPageOptions: [10, 50, 100, 500, 1000]
        }}
        enableStickyHeader={true}
        enableStickyFooter={true}
        enableColumnPinning={true}
        isLoading={filterValues.loading}
        muiTableBodyCellProps={{
          sx: {
            fontSize: '11px',
            textAlign: 'left',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            padding: '2px 10px'
          },
        }}
        muiTableHeadCellProps={{
          sx: {
            fontSize: '10px',
            fontWeight: '800',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            textAlign: 'center',
            padding: '2px 10px'
          }
        }}
        muiTableBodyRowProps={{
          sx: {
            "& td": {
              padding: "2px 10px",
            },
            textAlign: 'left',
          },
        }}
      >
      </GenericGrid>
      <ShippingConfig
        visible={shippingConfigVisible}
        onClose={() => setShippingConfigVisible(false)}
      />
    </div>
  );
}

export default EcomOrders;
